import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useRegisterReload } from '../../../hooks'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../../Button'
import { EmailDraftProvider } from '../../Email'
import { useRequestProfileContext } from '../RequestProfile.hooks'

import {
  QA_NAME_REQUEST_PROFILE_OPEN_ACTIVITIES,
  REQUEST_PROFILE_OPEN_ACTIVITIES_DRAFT_PREFIX,
} from './RequestProfileOpenActivities.constants'
import { useRequestProfileOpenActivities } from './RequestProfileOpenActivities.hooks'
import { RequestProfileOpenActivitiesTable } from './RequestProfileOpenActivitiesTable'

import * as styles from './RequestProfileOpenActivities.module.css'

function RequestProfileOpenActivities({
  scrollContainerRef,
  onReloadCounters,
}) {
  const { t } = useTranslation()

  const { registerOpenActivitiesReload, requestData } =
    useRequestProfileContext()

  const [isOpen, setOpen] = useState(false)

  const openActivities = useRequestProfileOpenActivities(requestData?.id)

  const { handleReload, isLoading, total } = openActivities

  useRegisterReload({
    reload: handleReload,
    onRegisterReload: registerOpenActivitiesReload,
  })

  function handleToggle() {
    setOpen(prevIsOpen => !prevIsOpen)
  }

  const isVisible = isLoading || total > 0

  return isVisible ? (
    <div className={styles.RequestProfileOpenActivities}>
      <ButtonArrow
        className={styles.toggle}
        height={BUTTON_HEIGHT_24}
        iconPlacement={BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER}
        isGrey={false}
        isOpen={isOpen}
        qaName={QA_NAME_REQUEST_PROFILE_OPEN_ACTIVITIES}
        text={t('RequestProfileOpenActivities.OpenActivitiesTitleKey', {
          itemsCount: total,
        })}
        onClick={handleToggle}
      />
      {isOpen ? (
        <div className={styles.content}>
          <EmailDraftProvider
            prefix={`${REQUEST_PROFILE_OPEN_ACTIVITIES_DRAFT_PREFIX}-${requestData?.id}`}
          >
            <RequestProfileOpenActivitiesTable
              openActivities={openActivities}
              scrollContainerRef={scrollContainerRef}
              onReloadCounters={onReloadCounters}
            />
          </EmailDraftProvider>
        </div>
      ) : null}
    </div>
  ) : null
}

export default RequestProfileOpenActivities
